import axios from "axios";
import config from "configs/config";
import apiClient from "lib/api-client";
import { getUserDetail } from "utils/getUserDetailsHelper";

//--------------- Get All Roles ---------------------\\
// export const getAllRoles = async () => {
//   const loginUser = getUserDetail("_id");
//   let response = await apiClient.get(`${config.baseUrl}/api/v1/role/getAllRolesWithRights/${loginUser}`);
//   return response.data;
// };
export const getAllRoles = async () => {
  const loginUser = getUserDetail("_id");
  let response = await apiClient.get(`${config.baseUrl}/api/v1/role/getAllRolesWithRightsForWeb/${loginUser}`);
  return response.data;
};

//--------------- Get Specific Role Rights ---------------------\\
// export const getSpecificRole = async (roleName) => {
//   const encodedRoleName = encodeURIComponent(roleName);
//   const loginUser = getUserDetail("_id");
//   let response = await apiClient.get(`${config.baseUrl}/api/v1/role/getSpecificRoleRights/${loginUser}/${encodedRoleName}`);
//   return response.data;
// };

export const getSpecificRole = async (roleName) => {
  const loginUser = getUserDetail("_id");
  let response = await apiClient.get(`${config.baseUrl}/api/v1/role/getSpecificRoleRights/${loginUser}?roleName=${roleName}`);
  return response.data;
};

//--------------- Get Breco Client Groups ---------------------\\
export const getBrecoClientGroups = async () => {
  let response = await apiClient.get(`https://breco.binnys.app/api/client-groups`);
  return response.data;
};

//--------------- Create Roles ------------------------\\

export const createRoles = async (RoleName) => {
  let response = await apiClient.post(`${config.baseUrl}/api/v1/role/createRole`, {
    roleName: RoleName?.trim(),
  });
  return response.data;
};

//-------------- Edit/Delete Roles -----------------------------\\

export const removeRoles = async (rolesToBeRemoved, isDelete) => {
  let response = await apiClient.post(`${config.baseUrl}/api/v1/role/editRoles`, {
    roleIds: rolesToBeRemoved,
    isDelete: isDelete,
  });
  return response.data;
};

//------------- Before Remove Check Whether this Role is assign to  any User or Not ------------\\
export const checkUserWithRole = async (rolesToBeRemoved) => {
  let response = await apiClient.post(`${config.baseUrl}/api/v1/role/roleAssignToUser`, {
    roleId: rolesToBeRemoved,
  });
  return response.data;
};

export const getProjectRoles = async ({ projectName }) => {
  let response = await apiClient.get(`${config.baseUrl}/api/v1/role/projectRoles/${projectName}`);
  return response.data;
};

export const getAllowCompanyIps = async () => {
  let response = await apiClient.get(`${config.baseUrl}/api/v1/ip?networkType=Company`);
  return response.data;
};
